export default function LoadingScreen() {
    return (
        <div className='h-full w-full p-6'>
            <title>Performance Monitoring</title>
            <div className="h-3/4 w-full flex items-center justify-center">
                <img className="h-12 animate-bounce" src={new URL('../images/icon.svg', import.meta.url)} alt="logo" />
            </div>
        </div>
    );
}
